import React, { Fragment, useState, useLayoutEffect, useEffect } from 'react';
import styled from 'styled-components';
import { getToken } from '../utils/formFunctions';
import { Progress, typography, Button } from '@awesomecomponents/mux';
import { BREAKPOINTS } from '@awesomecomponents/mux/core/spacing';
import brandingColors from '@awesomecomponents/mux/core/colors/colors';
import ErrorModal from './ErrorModal';
import { onRedirectAfterExit } from '../utils/modalFunctions';
import { appConstants } from '../utils/appConstants';
import useFetch from '../utils/useFetch';
import { useHistory } from 'react-router-dom';
import { removeAuth } from '../utils/authFunctions';
import { bffRoutes } from '../utils/configuration';
import logo from '../resources/default.svg';

const RootContentDiv = styled.div`
  margin: 0% 8%;
  height: 70vh;

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    display: block;
    margin: 0;
    width: 100%;
  }
`;
const SaveExitWrapper = styled.div`
  text-align: center;
  margin: 30px;
`;

const DownloadWrapper = styled.div`
  text-align: center;
  margin: 30px;
`;

const TextWrapper = styled.div`
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize};
  font-weight: ${typography.fontWeightLight};
  color: ${brandingColors.light_1_dark_navy};
`;

const DownloadActionLink = styled.a`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize};
  line-height: 1.25;
  font-weight: ${typography.fontWeightLight};
  color: ${brandingColors.link_green};
  text-decoration: underline;
`;

const Form = ({
  business_unit,
  form_name,
  flow,
  lang,
  langContent,
  isAuthenticated,
  setIsAuthenticated,
  setIsExitModalOpen,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const history = useHistory();

  const { MANULIFE_URL, REDIRECT_ROUTE } = appConstants;

  const { data, getData } = useFetch({ result: null, isLoading: false, error: null });

  const { EXIT, DOWNLOAD_PDF, DOWNLOAD_TEXT, DOWNLOAD_ARIA_LABEL } = langContent;
  //Similar to useEffect but this one runs after react finishes DOM updates and before it paints to browswer
  useLayoutEffect(() => {
    //render loading indicator when loading
    setIsLoading(true);
    getToken(business_unit, form_name, flow, setIsLoading, setIsError, setIsSubmitted, lang, setPdfUrl);
  }, [business_unit, form_name, flow, lang]);

  useEffect(() => {
    //this efflect runs when 200 repsonse comes back from server.
    if (data.result && !data.isLoading && !data.error) {
      if (isAuthenticated) {
        removeAuth();
        setIsAuthenticated(false);
      }
      history.push(REDIRECT_ROUTE);
    }
  }, [data, isAuthenticated, setIsAuthenticated, setIsExitModalOpen, history, MANULIFE_URL, REDIRECT_ROUTE]);

  const onDocumentClick = (e) => {
    e.preventDefault();

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(pdfUrl);
    }
    else {
        window.open(pdfUrl);
    }
  };
  return (
    <Fragment>
      {isLoading && <Progress />}
      <RootContentDiv key={form_name} className="target-div" data-testid="formTargetWrapper" />
      {pdfUrl && isSubmitted && (
        <DownloadWrapper>
          <TextWrapper>{DOWNLOAD_TEXT}</TextWrapper>
          <DownloadActionLink
            data-testid="downloadPdf"
            href={pdfUrl}
            key="download_pdf"
            target="_blank"
            onClick={(e) => onDocumentClick(e)}
          >
            {DOWNLOAD_PDF} <img src={logo} area-label={DOWNLOAD_ARIA_LABEL} alt={DOWNLOAD_ARIA_LABEL} />
          </DownloadActionLink>
        </DownloadWrapper>
      )}
      <SaveExitWrapper>
        {isSubmitted && (
          <Button
            id="formhero-exit"
            data-testid="formhero-exit"
            ariaLabel="exit and navigate to manulife"
            onClick={() => getData(bffRoutes.getLogoutFinal())}
            saving={data.isLoading}
            disabled={data.isLoading}
            disableClickEffect={true}
          >
            {EXIT.BUTTON_EXIT}
          </Button>
        )}
      </SaveExitWrapper>
      {isError && <ErrorModal isErrorModalOpen={isError} lang={lang} onRedirectAfterExit={onRedirectAfterExit} />}
    </Fragment>
  );
};

export default Form;
